import React, { useState } from 'react';
import { FaTag, FaTimes, FaPlus, FaWhatsapp, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import PopupPage from './Popup';
import {  FaInfoCircle, FaCamera, FaFileUpload, FaVideo } from 'react-icons/fa';

const Button = ({ onClick, children, variant = 'primary', className = '' }) => {
  const baseClasses = `px-3 py-1.5 rounded-md font-medium text-sm focus:outline-none flex items-center gap-1.5`;
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary',
    secondary: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
    danger: 'bg-red-500 text-white hover:bg-red-600',
    whatsapp: 'bg-green-500 text-white hover:bg-green-600',
  };
  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

const NoteItem = ({ date, text, type, onClick }) => (
  <div
    className="bg-white p-4 rounded-md shadow-sm border flex justify-between items-start mb-4 cursor-pointer"
    onClick={onClick}
  >
    <div className="w-full">
      <p className="text-gray-500 text-xs font-medium mb-1">{date}</p>
      <p
        className="text-gray-900 text-sm font-medium overflow-hidden text-ellipsis"
        style={{ display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}
      >
        {text}
      </p>
    </div>
    <span
      className={`text-xs px-2 py-1 rounded-md self-start ${
        type === 'Private' ? 'bg-purple-100 text-purple-500' : 'bg-gray-200 text-gray-600'
      }`}
    >
      {type}
    </span>
  </div>
);

const TaskItem = ({ text, checked, onChange }) => (
  <div className="bg-white p-2 rounded-md shadow-sm border mb-2 flex items-center gap-3 ">
    <CustomCheckbox checked={checked} onChange={onChange} />
    <p className="text-gray-700 text-sm truncate font-medium w-3/4">{text}</p>
  </div>
);

const CustomCheckbox = ({ checked, onChange }) => (
  <div className="relative w-4 h-4">
    <input
      type="checkbox"
      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      checked={checked}
      onChange={onChange}
    />
    <div className={` w-full h-full rounded border-2 ${checked ? 'bg-primary border-primary' : 'bg-white border-gray-400'}`}></div>
  </div>
);

const ReactFlowScreen = () => {
  const [openStep, setOpenStep] = useState(null);
  const [checklistStatus, setChecklistStatus] = useState({});
  const [notes, setNotes] = useState([
    { id: 1, date: 'Apr 2, 2023', text: 'The case must be finished. It should finish before 1st of January.', type: 'Private' },
    { id: 2, date: 'Apr 5, 2023', text: 'Visit us at Thursday at the office.', type: 'Public' },
  ]);
  const [tasks, setTasks] = useState([
    { id: 1, text: 'Set up meeting', checked: false },
    { id: 2, text: 'Translate birth cert.', checked: false },
    { id: 3, text: 'Submit application', checked: false },
    { id: 4, text: 'Review documents', checked: false },
  ]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState('');
  const [popupContent, setPopupContent] = useState('');
  const [editId, setEditId] = useState(null);
  const [visibility, setVisibility] = useState('Private');
  const [showModal, setShowModal] = useState(false);

  const toggleStep = (stepIndex) => {
    setOpenStep(openStep === stepIndex ? null : stepIndex);
  };

  const openPopup = (type, content = '', id = null, vis = 'Private') => {
    setPopupType(type);
    setShowPopup(true);
    setPopupContent(content);
    setEditId(id);
    setVisibility(vis);
  };

  const confirmPopup = () => {
    if (popupType === 'note') {
      if (editId) {
        setNotes(notes.map((note) => (note.id === editId ? { ...note, text: popupContent, type: visibility } : note)));
      } else {
        setNotes([...notes, { id: Date.now(), text: popupContent.trim(), type: visibility }]);
      }
    } else if (popupType === 'task') {
      if (editId) {
        setTasks(tasks.map((task) => (task.id === editId ? { ...task, text: popupContent } : task)));
      } else {
        setTasks([...tasks, { id: Date.now(), text: popupContent.trim(), checked: false }]);
      }
    }
    setShowPopup(false);
  };

  const onRowClick = (id) => {
    setShowModal(true);
  };
  const handleTaskEdit = (taskId, newText) => {
    setTasks((prevTasks) =>
      prevTasks.map((task) =>
        task.id === taskId ? { ...task, text: newText } : task
      )
    );
  };
  
  return (
    <div className="p-0 pt-4 max-w-6xl mx-auto font-sans text-gray-700">
      <div className="flex justify-between items-center border-b pb-4">
  
        <div className="flex items-center gap-3"> 

          <div className="bg-pink-500 w-5 h-5 rounded-md"></div>
          <h1 className="text-xl font-bold text-gray-900">Car Accident Case - 119876</h1>
        </div>
             
        <div className="flex gap-2">
          <Button onClick={() => openPopup('task')}>
            <FaPlus /> Add Task
          </Button>
          <Button onClick={() => openPopup('note')}>
            <FaPlus /> Add Note
          </Button>
          <Button onClick={() => alert('Messages')} variant="whatsapp">
            <FaWhatsapp /> Go to Messages
          </Button>
        </div>
      </div>

 {/**sidebar */}
      <div className="mt-6 grid grid-cols-4 gap-4">
      

   


        <div className="col-span-1 bg-white p-4 rounded-md shadow-sm border overflow-y-auto h-[calc(100vh-150px)]" style={{ marginLeft: '0' }}> 

        <Button variant="primary" className="w-full mb-6 flex justify-center items-center h-12">
            <span className="text-center">New Node</span> <FaPlus />
          </Button>

          {/* Line Types */}
          <div className="mb-6">
            <h3 className="text-sm font-medium text-gray-700 mb-2">LINE TYPES</h3>
            <div className="flex gap-2">
              <Button variant="secondary" className="w-1/2 py-2">Solid</Button>
              <Button variant="secondary" className="w-1/2 py-2">Dashed</Button>
            </div>
          </div>

          {/* Checklist Templates */}
          <div className="mb-6">
            <h3 className="text-sm font-medium text-gray-700 mb-2">CHECKLIST TEMPLATES</h3>
            <div className="grid grid-cols-2 gap-3">
              <Button variant="secondary" className="p-4 bg-white shadow-md">
                <FaInfoCircle size={20} className="mb-2" /> Info Task
              </Button>
              <Button variant="secondary" className="p-4 bg-white shadow-md">
                <FaCamera size={20} className="mb-2" /> Image Task
              </Button>
              <Button variant="secondary" className="p-4 bg-white shadow-md">
                <FaFileUpload size={20} className="mb-2" /> Upload File
              </Button>
              <Button variant="secondary" className="p-4 bg-white shadow-md">
                <FaVideo size={20} className="mb-2" /> Video Task
              </Button>
              <Button variant="primary" className="col-span-2 py-2">
                <FaPlus /> New Task
              </Button>
            </div>
          </div>

          <h2 className="font-semibold text-sm text-gray-800 mb-4">Notes</h2>
          {notes.map((note) => (
            <NoteItem
              key={note.id}
              date={note.date}
              text={note.text}
              type={note.type}
              onClick={() => openPopup('note', note.text, note.id, note.type)}
            />
          ))}
       
        </div>

        <div className="col-span-3">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-gray-800">Case Steps</h2>
          </div>
          {['Applying for tourist visa', 'Another process step', 'Final step'].map((step, index) => (
            <div key={index} className="bg-white shadow-md rounded-md mb-4 p-4 border">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleStep(index)}
              >
                <span className="font-semibold text-gray-900 text-base">{step}</span>
                <span className="text-gray-500 text-sm">
                  {openStep === index ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </div>
              {openStep === index && (
                <div className="bg-white p-4 mt-2 rounded-md">
                  <table className="table-auto w-full text-sm">
                    <thead>
                      <tr className="border-b">
                        <th className="text-left py-4">Checklist</th>
                        <th className="text-left py-4">Assigned To</th>
                        <th className="text-left py-4">Due Date</th>
                        <th className="text-left py-4">Close Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tasks.map((task, idx) => (
                        <tr
                          key={idx}
                          className={
                            idx % 2 === 0
                              ? 'border-b bg-purple-50'
                              : 'border-b bg-white'
                          }
                          onClick={(e) => {
                            if (e.target.type !== 'checkbox') {
                              onRowClick(task);
                            }
                          }}
                        >
                          <td className="py-4 flex items-center gap-2 pl-2">
                            <CustomCheckbox
                              checked={task.checked}
                              onChange={() =>
                                setTasks((prevTasks) =>
                                  prevTasks.map((t) =>
                                    t.id === task.id ? { ...t, checked: !t.checked } : t
                                  )
                                )
                              }
                            />
                            {task.text}
                          </td>
                          <td className="py-4">Lawyer</td>
                          <td className="py-4">12.12.2024</td>
                          <td className="py-4">5 January 2025</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {showPopup && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-md shadow-lg w-96">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <FaTag className="text-gray-500 text-lg" />
                <h2 className="text-lg font-bold text-gray-800">
                  {editId ? 'Edit' : 'Add new'} {popupType === 'note' ? 'Note' : 'Task'}
                </h2>
              </div>
              <button onClick={() => setShowPopup(false)} className="text-gray-500 hover:text-gray-700">
                <FaTimes className="text-lg" />
              </button>
            </div>
            <textarea
              className="w-full p-2 border rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-purple-500"
              rows="4"
              value={popupContent}
              onChange={(e) => setPopupContent(e.target.value)}
            ></textarea>
            <div className="flex gap-2 mb-4">
              <Button
                variant={visibility === 'Private' ? 'primary' : 'secondary'}
                onClick={() => setVisibility('Private')}
              >
                Private
              </Button>
              <Button
                variant={visibility === 'Public' ? 'primary' : 'secondary'}
                onClick={() => setVisibility('Public')}
              >
                Public
              </Button>
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="secondary" onClick={() => setShowPopup(false)}>
                Cancel
              </Button>
              <Button onClick={confirmPopup}>{editId ? 'Save' : 'Confirm'}</Button>
            </div>
          </div>
        </div>
      )}

{showModal && (
        <PopupPage
          initialModal="upload" // Automatically opens the Upload modal
          onClose={() => setShowModal(false)} // Closes the popup
        />
      )}
    </div>
  );
};

export default ReactFlowScreen;
